import { useState } from 'react';
import { savedTheme, type Theme } from '../saved-theme.js';

/**
 * Dark or light, on Account. Moved out of the header on 13 October to give the
 * header room; main.tsx applies the saved choice on every screen.
 *
 * Both options are shown at once, as the Lessons sorter does, so the control
 * says what the screen is now rather than what a tap would make it.
 */
export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(savedTheme.read);

  function choose(next: Theme) {
    savedTheme.apply(next);
    setTheme(next);
  }

  return (
    <div className="sorter" role="group" aria-label="Theme">
      {(['dark', 'light'] as const).map((option) => (
        <button key={option} type="button" aria-pressed={theme === option} onClick={() => choose(option)}>
          {option === 'dark' ? 'Dark' : 'Light'}
        </button>
      ))}
    </div>
  );
}
